import ThinkingImage from './ThinkingImage';

export default ThinkingImage;